import AccomplishmentModal, { AccomplishmentModalDispatchProps, AccomplishmentModalStateProps } from 'components/features/pfm/AccomplishmentModal/AccomplishmentModal'
import { StoreDispatch } from 'interfaces/component'
import { resetAccomplishmentsActionCreator } from 'actions/bountyActions'
import { createSelector } from 'reselect'
import { accomplishmentsSelector } from 'selectors/bountySelectors'
import { connectOptionally, createPositiveRendererProps, NO_RENDER, OptionalRendererProps } from 'tangle-shared'
import { isOnboardingClosedSelector } from 'selectors/onboardingSelectors'
import { hasTrackingAccomplishedRewards } from 'helpers/bountyHelpers'

const mapStateToProps = createSelector(
  accomplishmentsSelector,
  isOnboardingClosedSelector,
  (
    accomplishments,
    isOnboardingCompleted
  ): OptionalRendererProps<AccomplishmentModalStateProps> => {
    const hasTrackingRewards = hasTrackingAccomplishedRewards(accomplishments)
    if (!accomplishments.length || !isOnboardingCompleted || !hasTrackingRewards) {
      return NO_RENDER()
    }

    return createPositiveRendererProps({})
  }
)

const mapDispatchToProps = (dispatch: StoreDispatch): AccomplishmentModalDispatchProps => ({
  onCloseButtonClick: () => dispatch(resetAccomplishmentsActionCreator),
})

const AccomplishmentModalContainer = connectOptionally<
  AccomplishmentModalStateProps, AccomplishmentModalDispatchProps
>(mapStateToProps, mapDispatchToProps)(AccomplishmentModal)

export default AccomplishmentModalContainer
